import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const getSafeRedirectPath = (search) => {
  const params = new URLSearchParams(search);
  const redirect = params.get('redirect');

  if (
    !redirect ||
    !redirect.startsWith('/') ||
    redirect.startsWith('//') ||
    redirect.startsWith('/login')
  ) {
    return '/MemberPage';
  }

  return redirect;
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 37px)',
    height: 'calc(100vh - 37px)',
    padding: '20px',
    marginTop: 0,
    backgroundColor: '#f8f9fa',
    position: 'fixed',
    top: '37px',
    left: 0,
    right: 0,
    bottom: 0,
    overflowY: 'auto',
  },
  card: {
    width: '90%',
    maxWidth: '380px',
    backgroundColor: 'white',
    borderRadius: '10px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
    padding: '30px',
    transition: 'transform 0.3s ease',
    position: 'relative',
  },
  header: {
    textAlign: 'center',
    marginBottom: '25px',
  },
  title: {
    color: '#333',
    fontSize: '26px',
    marginBottom: '8px',
    fontWeight: 600,
  },
  subtitle: {
    color: '#666',
    fontSize: '15px',
  },
  error: {
    backgroundColor: '#fff0f0',
    color: '#e74c3c',
    padding: '10px',
    borderRadius: '5px',
    marginBottom: '15px',
    fontSize: '14px',
    borderLeft: '4px solid #e74c3c',
    width: '85%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '18px',
    width: '100%',
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    width: '85%',
    maxWidth: '300px',
    gap: '6px',
  },
  label: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#333',
    alignSelf: 'flex-start',
  },
  input: {
    width: '100%',
    padding: '10px 14px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '15px',
    transition: 'border-color 0.3s',
  },
  formActions: {
    width: '85%',
    maxWidth: '300px',
    marginTop: '5px',
  },
  button: {
    width: '100%',
    padding: '11px',
    backgroundColor: '#8e7a55',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    fontSize: '15px',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
};

const InvitePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  // 從 URL 查詢字串中取得臨時 token（由 OAuth callback 傳遞）
  const queryParams = new URLSearchParams(location.search);
  const tempToken = queryParams.get('token');
  const redirectPath = getSafeRedirectPath(location.search);

  const [inviteCode, setInviteCode] = useState('');
  const [error, setError] = useState('');

  const handleInviteChange = (e) => {
    setInviteCode(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!inviteCode) {
      setError(t('invite.errorEmpty', '請輸入邀請碼'));
      return;
    }
    try {
      // 呼叫邀請碼驗證 API
      await axios.post('/api/auth/verify-invite', {
        token: tempToken,
        inviteCode,
        redirect: redirectPath,
      });
      // 如果驗證成功，手動導向原本要前往的頁面
      navigate(redirectPath, { replace: true });
    } catch (err) {
      setError(
        err.response?.data?.error || t('invite.errorSubmit', '邀請碼驗證失敗')
      );
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <h1 style={styles.title}>{t('invite.title', '輸入邀請碼')}</h1>
          <p style={styles.subtitle}>
            {t('invite.subtitle', '請輸入您收到的邀請碼')}
          </p>
        </div>
        {error && <div style={styles.error}>{error}</div>}
        <form style={styles.form} onSubmit={handleSubmit}>
          <div style={styles.formGroup}>
            <label htmlFor="inviteCode" style={styles.label}>
              {t('invite.label', '邀請碼')}
            </label>
            <input
              type="text"
              id="inviteCode"
              name="inviteCode"
              value={inviteCode}
              onChange={handleInviteChange}
              placeholder={t('invite.placeholder', '請輸入邀請碼')}
              style={styles.input}
            />
          </div>
          <div style={styles.formActions}>
            <button type="submit" style={styles.button}>
              {t('invite.submit', '送出')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default InvitePage;
